import { z } from 'zod';
/**
 * Auswertungen (Modul `reports`, Paket Premium): Kennzahlen aus den Daten der anderen Module, nur lesend. Das Modul hat keine eigenen Tabellen.
 * Alle Beträge in Cent, netto, sofern nicht anders genannt. Was ein Mandant nicht gebucht hat (zum Beispiel Flotte oder Schichtplanung), meldet die Auswertung als `null`,
 * dann blendet die Oberfläche den Abschnitt aus.
 */
export const reportsOverviewQuery = z.object({
    /** Das Auswertungsjahr, ohne Angabe das laufende Jahr */
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
export const AGING_LABELS = {
    not_due: 'Noch nicht fällig',
    d1_30: '1 bis 30 Tage überfällig',
    d31_60: '31 bis 60 Tage überfällig',
    d61_90: '61 bis 90 Tage überfällig',
    d90_plus: 'Über 90 Tage überfällig',
};
//# sourceMappingURL=reports.js.map